import { render, staticRenderFns } from "./addGoods.vue?vue&type=template&id=bce78f9e&scoped=true"
import script from "./addGoods.vue?vue&type=script&lang=js"
export * from "./addGoods.vue?vue&type=script&lang=js"
import style0 from "./addGoods.vue?vue&type=style&index=0&id=bce78f9e&prod&scoped=true&lang=css"
import style1 from "./addGoods.vue?vue&type=style&index=1&id=bce78f9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce78f9e",
  null
  
)

export default component.exports